var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_415_61433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1475 22.7869C26.2517 22.8423 26.2517 22.9916 26.1475 23.047L20.6618 25.9646C20.6358 25.9783 20.6146 25.9996 20.6009 26.0255L17.6833 31.5112C17.6279 31.6154 17.4786 31.6154 17.4232 31.5112L14.5056 26.0255C14.4919 25.9996 14.4707 25.9783 14.4448 25.9646L8.95897 23.047C8.85479 22.9916 8.85479 22.8423 8.95897 22.7869L14.4448 19.8694C14.4707 19.8556 14.4919 19.8344 14.5056 19.8085L17.4232 14.3227C17.4786 14.2185 17.6279 14.2185 17.6833 14.3227L20.6009 19.8085C20.6146 19.8344 20.6358 19.8556 20.6618 19.8694L26.1475 22.7869Z",
    fill: "#FFCA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4949 20.5982C37.6007 20.6532 37.6007 20.8045 37.4949 20.8595L34.6939 22.3169C34.6671 22.3309 34.6452 22.3528 34.6312 22.3796L33.1738 25.1806C33.1188 25.2864 32.9675 25.2864 32.9125 25.1806L31.455 22.3796C31.4411 22.3528 31.4192 22.3309 31.3924 22.3169L28.5913 20.8595C28.4856 20.8045 28.4856 20.6532 28.5913 20.5982L31.3924 19.1408C31.4192 19.1268 31.4411 19.1049 31.455 19.0781L32.9125 16.277C32.9675 16.1713 33.1188 16.1713 33.1738 16.277L34.6312 19.0781C34.6452 19.1049 34.6671 19.1268 34.6939 19.1408L37.4949 20.5982Z",
    fill: "#FFCA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.012 11.7153C30.1178 11.7704 30.1178 11.9217 30.012 11.9767L27.211 13.4341C27.1842 13.4481 27.1623 13.47 27.1483 13.4968L25.6909 16.2978C25.6359 16.4036 25.4846 16.4036 25.4295 16.2978L23.9721 13.4968C23.9582 13.47 23.9363 13.4481 23.9095 13.4341L21.1084 11.9767C21.0027 11.9217 21.0027 11.7704 21.1084 11.7153L23.9095 10.2579C23.9363 10.244 23.9582 10.2221 23.9721 10.1953L25.4295 7.39423C25.4846 7.28847 25.6359 7.28847 25.6909 7.39423L27.1483 10.1953C27.1623 10.2221 27.1842 10.244 27.211 10.2579L30.012 11.7153Z",
    fill: "#FFCA7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_415_61433",
    x: -5,
    y: -6,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_61433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_61433",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateStars);
export default __webpack_public_path__ + "static/media/empty-state-stars.6c48d23619174964a351107147c9772e.svg";
export { ForwardRef as ReactComponent };